// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"xt","loaded":"xu","emblaSlide":"xv","arrowButton":"xw"};